module.exports = __webpack_public_path__ + "img/epam.928cdcf6.png";